<template>
  <form type="submit"
        method="POST"
        ref="dataConcentratorForm"
        :action="'/data-concentrator/' + concentrator.id"
        @submit.prevent="() => console.log('Preventing submit via enter')">
<!--    Make sure it submits as a PUT request-->
    <input type="hidden" name="_method" value="PUT">
    <input type="hidden" name="_token" :value="csrf" />
    <div    class="">
      <span>
        Editing {{ concentrator.thing_name }}
      </span>

      <div class="mt-4 pb-4">
        <span class="text-lg text-gray-900 text-left font-semibold">Shadow Name</span>
        <pre>{{concentrator.thing_name}}</pre>
      </div>

      <div class="mt-4 pb-4">
        <span class="text-lg text-gray-900 text-left font-semibold">Server Type</span>
        <select2
          v-model:value="serverType"
          :options="serverTypes"
          :multiple="false"
          :close-on-select="true"
          placeholder="Select a server type (if desired)"
          name="server_type"
        >
        </select2>
      </div>

      <div v-if="serverType">
        <div class="mt-4 pb-4">
          <span class="text-lg text-gray-900 text-left font-semibold">Number of Slots</span>
          <select2
            v-model:value="serverSlots"
            :options="numberOfPointsOptions"
            :multiple="false"
            :close-on-select="true"
            name="server_slots"
          >
          </select2>
        </div>

        <div v-if="serverSlots > 0" class="flex flex-col">
          <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                <table class="min-w-full divide-y divide-gray-200">
                  <thead class="bg-gray-50">
                  <tr>
                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Slot</th>
                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Meter</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(slotNumber, indexNumber) in [...Array(parseInt(serverSlots)).keys()]"
                      :key="indexNumber"
                      :class="indexNumber % 2 === 0 ? 'bg-white' : 'bg-gray-50'">
                    <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      Slot {{ slotNumber }}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      <select2
                        :value="findMeterInRelatedMeters(slotNumber)"
                        :options="allowedPointsOptions"
                        :allow-clear="true"
                        :multiple="false"
                        :close-on-select="true"
                        :name="'points_' + slotNumber"
                        placeholder="Select Points"
                      ></select2>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
<!--      Client Code -->

      <div class="mt-4 pb-4">
        <span class="text-lg text-gray-900 text-left font-semibold">Client Type</span>
        <select2
          v-model:value="clientType"
          :options="clientTypes"
          :multiple="false"
          :close-on-select="true"
          placeholder="Select a client type (if desired)"
          name="client_type"
        >
        </select2>
      </div>

      <div v-if="clientType">
        <div class="mt-4 pb-4">
          <span class="text-lg text-gray-900 text-left font-semibold">Refresh Frequency (Seconds)</span>
          <input type="text"
                 v-model="clientFrequency"
                 class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                 @keyup.enter=""
                 name="client_frequency"
                 placeholder="Data Refresh Frequency (seconds)" />
        </div>
      </div>

      <div v-if="clientType">
        <div class="mt-4 pb-4">
          <span class="text-lg text-gray-900 text-left font-semibold">BACnet Max Params per Call</span>
          <input type="text"
                 v-model="maxCalls"
                 class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                 @keyup.enter=""
                 name="max_calls"
                 placeholder="BACnet Max Params per Call (1000 = unlimited)" />
        </div>
      </div>

      <div v-if="clientType">
        <div class="mt-4 pb-4">
          <span class="text-lg text-gray-900 text-left font-semibold">Number of Slots</span>
          <select2
            v-model:value="clientSlots"
            :options="numberOfPointsOptions"
            :multiple="false"
            :close-on-select="true"
            name="client_slots"
          >
          </select2>
        </div>
      </div>

      <div v-if="clientType && clientType === 'bacnet_ip'">
        <div class="mt-4 pb-4">
          <span class="text-lg text-gray-900 text-left font-semibold">IP Addresses</span>
          <input type="text"
                 v-model="temporaryIpAddressString"
                 class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                 @keyup.enter="addTemporaryIpAddress"
                 name="client_ip_addresses"
                 placeholder="Enter new IP Address" />
          <ul class="list-disc list-inside">
            <li v-for="ipAddress in clientIpAddresses">
              {{  ipAddress }}
            </li>
            <li v-if="clientIpAddresses.length === 0">
              No IP Addresses have been added!
            </li>
          </ul>
        </div>
      </div>

      <div v-if="clientSlots > 0 && clientType === 'bacnet_ip'" class="mt-4 pb-4">
        <span class="text-lg text-gray-900 text-left font-semibold">Apply To All</span>
        <div class="flex space-x-4 mt-2">
          <select2
            v-model:value="globalClientIp"
            :options="clientIpAddresses"
            :allow-clear="true"
            :multiple="false"
            :close-on-select="true"
            placeholder="Select IP Address"
          ></select2>
          <select2
            v-model:value="globalClientObjectType"
            :options="bacnetClientDataTypes"
            :allow-clear="true"
            :multiple="false"
            :close-on-select="true"
            placeholder="Select Object Type"
          ></select2>
        </div>
      </div>

      <div v-if="clientSlots > 0 && clientType === 'bacnet_ip'" class="flex flex-col">
        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                <tr>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Slot</th>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">IP Address</th>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Object Type</th>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Object Index</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(slotNumber, indexNumber) in [...Array(parseInt(clientSlots)).keys()]"
                    :key="indexNumber + 'client'"
                    :class="indexNumber % 2 === 0 ? 'bg-white' : 'bg-gray-50'">
                  <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    Slot {{ slotNumber }} ({{ convertSlotNumberToHexPrefix(slotNumber) }})
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    <select2
                      :value="findClientInManifest(slotNumber, 'client_ip_address')"
                      :options="clientIpAddresses"
                      :allow-clear="true"
                      :multiple="false"
                      :close-on-select="true"
                      :name="'client_ip_address_' + slotNumber"
                      placeholder="Select IP Address"
                    ></select2>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    <select2
                      :value="findClientInManifest(slotNumber, 'client_object_type')"
                      :options="bacnetClientDataTypes"
                      :allow-clear="true"
                      :multiple="false"
                      :close-on-select="true"
                      :name="'client_object_type_' + slotNumber"
                      placeholder="Select Object Type"
                    ></select2>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    <input type="text"
                           :value="findClientInManifest(slotNumber, 'client_object_index')"
                           class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                           @keyup.enter=""
                           :name="'client_object_index_' + slotNumber"
                           placeholder="Enter Object Index" />
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>


      <button
        type="button"
        @click="realSubmit"
        class="cursor-pointer no-underline hover:no-underline focus:no-underline active:no-underline relative inline-flex items-center px-4 py-2 border text-sm leading-5 font-medium
                    rounded-md w-full flex justify-center items-center bg-blue-600 hover:bg-blue-500 focus:bg-blue-500 active:bg-blue-600
                    text-white hover:text-white focus:text-white active:text-white
                    border-transparent hover:border-blue-700 focus:border-blue-700 active:border-transparent"> Save Concentrator Profile </button>

    </div>
  </form>
</template>

<script>
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import FloatingInput from "@/components/elements/FloatingInput";
import Select2 from "@/components/elements/select2"
import ButtonBluePrimary from "@/components/elements/buttons/ButtonBluePrimary";
import ButtonGreenPrimary from "@/components/elements/buttons/ButtonGreenPrimary";
import _ from "lodash";
import UndecoratedLink from "@/components/EnterpriseDashboard/undecorated-link";
import {companyMixin} from "@/mixins/companyMixin";

export default {
    name: "DataConcentratorEdit",
    mixins: [ iconNamesMixin, companyMixin],
    components: {UndecoratedLink, ButtonGreenPrimary, ButtonBluePrimary, FloatingInput, Select2},
    props: {
      concentrator: {
        type: Object,
        required: true
      },
      allowedPoints: {
        type: Object,
        required: true
      },
      serverTypes: {
        type: Object,
        required: true
      },
      clientTypes: {
        type: Object,
        required: true
      },
    },
    data() {
        return {
            // Editing Modal
            showEditModal: false,
            name: '',
            serverType: '',
            serverSlots: 0,
            clientType: '',
            clientSlots: 0,
            clientFrequency: 0,
            maxCalls: 0,
            clientIpAddresses: {},
            temporaryIpAddressString: '',
            globalClientIp: null,
            globalClientObjectType: null,
            points: {},
            numberOfPointsOptions: {... _.range(200)},
            bacnetClientDataTypes: {'analogInput': 'analogInput', 'analogValue': 'analogValue','binaryInput':'binaryInput'},
            shouldSubmit: false,
        }
    },
    created() {
      if (this.concentrator.server_manifest.hasOwnProperty('slots')) {
        this.serverSlots = this.concentrator.server_manifest.slots
      }
      if(this.concentrator.server_manifest.hasOwnProperty('type')) {
        this.serverType = this.concentrator.server_manifest.type
      }
      if(this.concentrator.server_manifest.hasOwnProperty('points')) {
        this.points = this.concentrator.server_manifest.points
      }
      if (this.concentrator.client_manifest.hasOwnProperty('slots')) {
        this.clientSlots = this.concentrator.client_manifest.slots
      }
      if(this.concentrator.client_manifest.hasOwnProperty('type')) {
        this.clientType = this.concentrator.client_manifest.type
      }
      if(this.concentrator.client_manifest.hasOwnProperty('frequency')) {
        this.clientFrequency = this.concentrator.client_manifest.frequency
      }
      if(this.concentrator.client_manifest.hasOwnProperty('maxCalls')) {
        this.maxCalls = this.concentrator.client_manifest.maxCalls
      }
      if(this.concentrator.client_manifest.hasOwnProperty('points')) {
        _.forEach(this.concentrator.client_manifest.points, function(value, key){
          if(! _.isNil(value.client_ip_address)){
            this.clientIpAddresses[value.client_ip_address] = value.client_ip_address;
          }
        }.bind(this));
      }
    },
    mounted() {
        
    },
    methods: {
        findMeterInRelatedMeters(slotNumber){
            slotNumber = slotNumber.toString();
            let resultMeter = _.find(this.concentrator.server_manifest.points, function(obj, key){
                return obj.order.toString() === slotNumber;
            });
            if(! _.isNil(resultMeter)){
                return resultMeter.id;
            } else {
                return null;
            }
        },
        findClientInManifest(slotNumber, propertyName){
            slotNumber = slotNumber.toString();
            let resultMapping = _.find(this.concentrator.client_manifest.points, function(obj, key){
                return obj.order.toString() === slotNumber;
            });
            if(! _.isNil(resultMapping)){
                return resultMapping[propertyName];
            } else {
                return null;
            }
        },
        profileMappingLink(row) {
          return this.company.buildCompanyRoute('concentrator-profiles/' + row.id)
        },
        addTemporaryIpAddress(event) {
          event.preventDefault();
          this.clientIpAddresses[this.temporaryIpAddressString] = this.temporaryIpAddressString;
          this.temporaryIpAddressString = ''
        },
       submit(){
          if(this.shouldSubmit){
            this.$refs.dataConcentratorForm.submit();
          } else {
            console.log('Not submitting')
          }
       },
        realSubmit(){
          this.shouldSubmit = true;
          this.submit();
        },
      convertSlotNumberToHexPrefix(slotNumber){
          // Please note that this logic is based on DataConcentrator::determineClientSerialNumber.
          // If that logic changes, this logic will need to change as well.
        const alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const firstCharacterIncrement = 16 + Math.floor(slotNumber / 36); // 16 offsets to 'G'
        const secondCharacterIncrement = slotNumber % 36;

        return alphabet[firstCharacterIncrement] + alphabet[secondCharacterIncrement];
      },
      applyIpToAll() {
        if (_.isNil(this.globalClientIp)) {
          return;
        }
        for (let i = 0; i < this.clientSlots; i++) {
          const elem = document.getElementsByName('client_ip_address_' + i)[0];
          if (elem) {
            $(elem).val(this.globalClientIp).trigger('change');
          }
        }
      },
      applyObjectTypeToAll() {
        if (_.isNil(this.globalClientObjectType)) {
          return;
        }
        for (let i = 0; i < this.clientSlots; i++) {
          const elem = document.getElementsByName('client_object_type_' + i)[0];
          if (elem) {
            $(elem).val(this.globalClientObjectType).trigger('change');
          }
        }
      }
    },
    computed: {
        allowedPointsOptions() {
            let keyedNames = {}
            _.forEach(this.allowedPoints, function(val){
                keyedNames[val.ID] = val.Name;
            })
            return keyedNames;
        },
      console: () => console,
    },
    watch: {
      globalClientIp() {
        this.$nextTick(() => this.applyIpToAll());
      },
      globalClientObjectType() {
        this.$nextTick(() => this.applyObjectTypeToAll());
      }
    },
}
</script>

<style scoped>

</style>